// extracted by mini-css-extract-plugin
export default {"aditionalActions":"extraActionsMenu_aditionalActions__xftUb","aditionalActionsMenu":"extraActionsMenu_aditionalActionsMenu__hmpR7","showMenu":"extraActionsMenu_showMenu__Lb47s"};